// extracted by mini-css-extract-plugin
export default {"soloContainer":"AccountDetailsForm_soloContainer__+xMJY","defaultContainer":"AccountDetailsForm_defaultContainer__bHqo8"};